var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-wrap",attrs:{"id":"app"}},[_vm._m(0),_c('main',{staticClass:"l-main"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"l-header"},[_c('p',{staticClass:"l-header__logo"},[_c('img',{attrs:{"src":require("../public/assets/img/logo_01.png"),"width":"150","alt":"ALPINE"}})])])
}]

export { render, staticRenderFns }